export default "__VITE_ASSET__srV3Xjd4__"